// extracted by mini-css-extract-plugin
export default {"dialog":"NewFolderDialog_dialog__qOC+x","actionsRow":"NewFolderDialog_actionsRow__ObfWQ"};